// @flow strict
export { default } from './Page';
